import { call, put } from "typed-redux-saga";
import { WebConfigurationClient } from "../../web-apis/web-configuration";
import { appDeploymentInfoSet } from "./appConfigSlice";
import { appInitializationFailed } from "../appStatus/appStatusSlice";

export function* getAppDeploymentInfo() {
    try {
        const appDeploymentInfo = yield* call(WebConfigurationClient.getDeploymentConfigInfo);
        yield* put(appDeploymentInfoSet(appDeploymentInfo));
    }
    catch (error) {
        console.log('An error occurred when trying to retrieve app config:')
        console.error(error);
        yield* put(appInitializationFailed((error as Error).toString()));
    }
}

/** Returns all relevant watches to be added to a main root watch saga */
export function getWatchesForAppDeploymentInfoSagas() {
    return [
        // currently nothing!
    ];
}
